// Destination regions from the EL AL contract data format guide.
const REGION = {
    ISRAEL: 'Israel',
    NORTH_AMERICA: 'North America',
    FAR_EAST: 'Far East',
    EUROPE: 'Europe',
    OTHER: 'Other',
};

// [ISO 3166-1 alpha-2 code, English names] per region; countries not listed fall into REGION.OTHER.
const COUNTRIES_BY_REGION = {
    [REGION.ISRAEL]: [
        ['IL', ['Israel']],
    ],
    [REGION.NORTH_AMERICA]: [
        ['US', ['United States', 'United States of America', 'USA']],
        ['CA', ['Canada']],
        ['MX', ['Mexico']],
    ],
    [REGION.FAR_EAST]: [
        ['CN', ['China']],
        ['JP', ['Japan']],
        ['KR', ['South Korea', 'Korea, Republic of', 'Republic of Korea']],
        ['KP', ['North Korea']],
        ['TW', ['Taiwan']],
        ['HK', ['Hong Kong']],
        ['MO', ['Macau', 'Macao']],
        ['MN', ['Mongolia']],
        ['VN', ['Vietnam', 'Viet Nam']],
        ['TH', ['Thailand']],
        ['KH', ['Cambodia']],
        ['LA', ['Laos']],
        ['MM', ['Myanmar']],
        ['MY', ['Malaysia']],
        ['SG', ['Singapore']],
        ['ID', ['Indonesia']],
        ['PH', ['Philippines']],
        ['BN', ['Brunei']],
        ['TL', ['Timor-Leste', 'East Timor']],
    ],
    [REGION.EUROPE]: [
        ['AL', ['Albania']],
        ['AD', ['Andorra']],
        ['AT', ['Austria']],
        ['BY', ['Belarus']],
        ['BE', ['Belgium']],
        ['BA', ['Bosnia and Herzegovina']],
        ['BG', ['Bulgaria']],
        ['HR', ['Croatia']],
        ['CY', ['Cyprus']],
        ['CZ', ['Czech Republic', 'Czechia']],
        ['DK', ['Denmark']],
        ['EE', ['Estonia']],
        ['FI', ['Finland']],
        ['FR', ['France']],
        ['DE', ['Germany']],
        ['GI', ['Gibraltar']],
        ['GR', ['Greece']],
        ['HU', ['Hungary']],
        ['IS', ['Iceland']],
        ['IE', ['Ireland']],
        ['IT', ['Italy']],
        ['XK', ['Kosovo']],
        ['LV', ['Latvia']],
        ['LI', ['Liechtenstein']],
        ['LT', ['Lithuania']],
        ['LU', ['Luxembourg']],
        ['MT', ['Malta']],
        ['MD', ['Moldova']],
        ['MC', ['Monaco']],
        ['ME', ['Montenegro']],
        ['NL', ['Netherlands', 'The Netherlands']],
        ['MK', ['North Macedonia', 'Macedonia']],
        ['NO', ['Norway']],
        ['PL', ['Poland']],
        ['PT', ['Portugal']],
        ['RO', ['Romania']],
        ['RU', ['Russia', 'Russian Federation']],
        ['SM', ['San Marino']],
        ['RS', ['Serbia']],
        ['SK', ['Slovakia']],
        ['SI', ['Slovenia']],
        ['ES', ['Spain']],
        ['SE', ['Sweden']],
        ['CH', ['Switzerland']],
        ['UA', ['Ukraine']],
        ['GB', ['United Kingdom', 'UK', 'Great Britain', 'England', 'Scotland', 'Wales', 'Northern Ireland']],
        ['VA', ['Vatican City', 'Holy See']],
    ],
};

module.exports = {
    REGION,
    COUNTRIES_BY_REGION,
};
